import React, { Component } from 'react'
import apiService from '../../services/apiservices'
import Select from 'react-select'

class Products extends Component {
    constructor() {
        super()
        this.state = {
            ProductsList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getProductListData()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getProductListData = () => {
        apiService.getProductDetailList()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                    if (listData.status === "SUCCESS") {
                        this.setState({
                            ProductsList: listData.data ? listData.data : {},
                        })
                    } else {
                        console.error("Filed response from Product list api")
                    }
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }

    render() {
        let list = {}
        list = Object.keys(this.state.ProductsList).map((index) => {
            return {
                label : this.state.ProductsList[index],
                value : index
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));
       

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={list}
                placeholder="Select Products(s)"
                multi
                onChange={(e) => { (e) ? this.props.productChange(e) : this.props.productChange([])}}
                />
            </div>
        )
    }
}

export default Products


// WEBPACK FOOTER //
// ./src/modules/Brands/Components/DropDowns/Products.js